import React from 'react';
import { connect } from 'react-redux';
import HeadingBlock from '$/components/global/heading';
import TranscriptsGrid from '$/components/transcripts-grid';
import { toastError, toastSuccess } from '$/store/toast/actions';

interface ITranscriptsProps {
  dispatchToastError: (message: string) => Promise<void>;
  dispatchToastSuccess: (message: string) => Promise<void>;
}

const Transcripts: React.FC<ITranscriptsProps> = ({ dispatchToastError, dispatchToastSuccess }) => {
  return (
    <React.Fragment>
      <section>
        <div>
          <HeadingBlock title={'Manage Transcriptions'} />
          <TranscriptsGrid dispatchToastError={dispatchToastError} dispatchToastSuccess={dispatchToastSuccess} />
        </div>
      </section>
    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchToastError: (message: string) => dispatch(toastError(message)),
  dispatchToastSuccess: (message: string) => dispatch(toastSuccess(message)),
});

export default connect(null, mapDispatchToProps)(Transcripts);
